module.exports = __webpack_public_path__ + "img/Arrow-Black.5183d432.svg";